import { Map } from 'immutable';

import { aiGenerated, aiGeneratedV1 } from './ai';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { FEATURE } from '../../../../constants/features';
import { VALUE } from '../../../../constants/product';

export function title({ channel, operation, preview, state, userFeatures }) {
  switch (operation) {
    case OPERATIONS[channel].TITLE.AI_GENERATED: {
      return userFeatures.get(FEATURE.AI_V2)
        ? aiGenerated({ attribute: ATTRIBUTE.TITLE, channel, preview, state })
        : aiGeneratedV1({ attribute: ATTRIBUTE.TITLE, channel, preview, state });
    }

    case OPERATIONS[channel].TITLE.FIND_AND_REPLACE: {
      return {
        payload: Map({
          type: operation,
          value: Map({
            find: preview.getIn([ATTRIBUTE.TITLE, FIND]),
            replace: preview.getIn([ATTRIBUTE.TITLE, REPLACE]),
          }),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.TITLE, VALUE]),
        }),
      };
    }
  }
}
